/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import { OriginType, PitStrategyData, SanctioningBodyEnum } from 'models/viewModels';
import { StreamRequestType } from './RSocketObject';
import { RSocketStreamBaseService } from './RSocketStreamBaseService';

class PitStrategyDataService extends RSocketStreamBaseService<PitStrategyData[], PitStrategyData> {
  protected async getStreamHistoryRequest(): Promise<PitStrategyData[]> {
    return axiosConfig(ApiRequestType.StreamMetricsApi)
      .post('/rest/backfill/pitStrategy', this.request)
      .then((response) => {
        return response.data as PitStrategyData[];
      })
      .catch(() => {
        return [];
      });
  }

  // We should explore not using localCache/delay since this stream shouldn't have a large flow of incoming data
  protected onDataCallback = (response: PitStrategyData) => {
    if (this.listeners.size > 0) {
      const prevPitData = [...this.localCache];
      const index = prevPitData.findIndex(
        (item) => item.vehicleNumber === response.vehicleNumber && item.lap === response.lap
      );
      if (index !== -1) {
        prevPitData[index] = response;
        this.localCache = prevPitData;
      } else {
        this.localCache = [...prevPitData, response];
      }
    }
  };

  async start() {
    this.delay = 1000;
    super.start();
  }
}

export const pitStrategyDataService: Map<SanctioningBodyEnum, PitStrategyDataService> = new Map(
  (Object.values(SanctioningBodyEnum) as SanctioningBodyEnum[])
    .filter((x) => typeof x === 'number')
    .map((sanctioningBody) => [
      sanctioningBody,
      new PitStrategyDataService({
        route: 'stream.pitStrategy',
        connectionType: StreamRequestType.MotorsportsStreamApi,
        originType: OriginType.STRATEGY,
        sanctioningBody: sanctioningBody,
      }),
    ])
);
